import React from 'react';

interface IMailProps {
  fill: string;
}

const CloudSync = ({ fill = '', ...props }: IMailProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_2314_49056"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="16"
    >
      <rect width="16" height="16" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_2314_49056)">
      <path
        d="M1.5 13.3332V11.9998H3.31667C2.75 11.5109 2.30556 10.9221 1.98333 10.2332C1.66111 9.54428 1.5 8.79984 1.5 7.99984C1.5 6.75539 1.87778 5.65817 2.63333 4.70817C3.38889 3.75817 4.34444 3.13317 5.5 2.83317V4.23317C4.72222 4.51095 4.08333 4.9915 3.58333 5.67484C3.08333 6.35817 2.83333 7.13317 2.83333 7.99984C2.83333 8.59984 2.95278 9.15262 3.19167 9.65817C3.43056 10.1637 3.75556 10.5998 4.16667 10.9665V9.33317H5.5V13.3332H1.5ZM8.83333 13.3332C8.27778 13.3332 7.80556 13.1387 7.41667 12.7498C7.02778 12.3609 6.83333 11.8887 6.83333 11.3332C6.83333 10.7998 7.01667 10.3415 7.38333 9.95817C7.75 9.57484 8.2 9.37206 8.73333 9.34984C8.92222 8.94984 9.20278 8.62484 9.575 8.37484C9.94722 8.12484 10.3667 7.99984 10.8333 7.99984C11.4222 7.99984 11.9306 8.1915 12.3583 8.57484C12.7861 8.95817 13.0444 9.43317 13.1333 9.99984C13.6 9.99984 14 10.1609 14.3333 10.4832C14.6667 10.8054 14.8333 11.1943 14.8333 11.6498C14.8333 12.1165 14.6722 12.5137 14.35 12.8415C14.0278 13.1693 13.6333 13.3332 13.1667 13.3332H8.83333ZM10.7667 7.33317C10.6889 6.87761 10.5389 6.45539 10.3167 6.0665C10.0944 5.67761 9.82222 5.33317 9.5 5.03317V6.6665H8.16667V2.6665H12.1667V3.99984H10.35C10.8278 4.42206 11.2194 4.9165 11.525 5.48317C11.8306 6.04984 12.0278 6.6665 12.1167 7.33317H10.7667ZM8.83333 11.9998H13.1667C13.2556 11.9998 13.3333 11.9665 13.4 11.8998C13.4667 11.8332 13.5 11.7554 13.5 11.6665C13.5 11.5776 13.4667 11.4998 13.4 11.4332C13.3333 11.3665 13.2556 11.3332 13.1667 11.3332H12V10.4998C12 10.1776 11.8861 9.90262 11.6583 9.67484C11.4306 9.44706 11.1556 9.33317 10.8333 9.33317C10.5111 9.33317 10.2361 9.44706 10.0083 9.67484C9.78055 9.90262 9.66667 10.1776 9.66667 10.4998V10.6665H8.83333C8.64444 10.6665 8.48611 10.7304 8.35833 10.8582C8.23056 10.9859 8.16667 11.1443 8.16667 11.3332C8.16667 11.5221 8.23056 11.6804 8.35833 11.8082C8.48611 11.9359 8.64444 11.9998 8.83333 11.9998Z"
        fill="#6B6C7B"
      />
    </g>
  </svg>
);

export default CloudSync;
